'use client';
import React, { useEffect, useState } from 'react';
import StayItemBox from '@/components/StayItemBox';
import Icons from './Icons';
import SwiperBox from './SwiperBox';
import 'swiper/css';
import 'swiper/css/scrollbar';
import SwiperClass from 'swiper/types/swiper-class';
import useWindowWidth from '@/hooks/useWindowWidth';
import useDeviceSize from '@/hooks/useDeviceSize';
import Spinner from '@/components/common/Spinner';

interface PartnerStoreListItem {
  id: number;
  storeName?: string;
  imageUrl?: string;
  imageName?: string;
  discountPrice?: number;
  salePrice?: number;
  region?: string;
  city?: string;
  standardPeopleCount?: number;
  maximumPersonnelCount?: number;
}

interface Props {
  title: string;
  type?: 'scroll' | 'pagination';
  hideScrollbar?: boolean;
  partnerStoreList?: PartnerStoreListItem[];
  isDesktop?: boolean;
  enableAutoplay?: boolean;
  autoplayDelay?: number;
  loading?: boolean;
}

const StayListBox = ({
  title,
  type = 'scroll',
  partnerStoreList,
  hideScrollbar = false,
  enableAutoplay = false,
  autoplayDelay = 3000,
  loading = false,
}: Props) => {
  const width = useWindowWidth();
  const isDesktop = useDeviceSize();

  const [swiperIndex, setSwiperIndex] = useState(0); // -> 페이지네이션용
  const [swiper, setSwiper] = useState<SwiperClass>(); // -> 슬라이드용

  // 2. 슬라이드 이벤트핸들러
  const handlePrev = () => {
    swiper?.slidePrev();
  };
  const handleNext = () => {
    swiper?.slideNext();
  };

  const onSwiper = (data: SwiperClass) => {
    setSwiper(data);
  };

  const onSwiperIndex = (data: number) => {
    setSwiperIndex(data);
  };

  return (
    <div className='pt-[115px] pb-[42px] border-b border-[#D2D2D2] min-h-[665px] mobile:min-h-[460px]'>
      {title && <div className='text-[32px] font-[600] mb-[18px] mobile:text-[20px]'>{title}</div>}
      <div>
        {loading ? (
          <div className='flex items-center justify-center h-[347px] mobile:h-[230px]'>
            <Spinner size={60} />
          </div>
        ) : (
          <>
            {type === 'scroll' && (
              <SwiperBox
                isMargin={true}
                // freeMode={true}
                slidesPerView={
                  width > 1000 && isDesktop ? 2.5 : width < 1000 && isDesktop ? 1.5 : !isDesktop ? 1 : 1
                }
                scrollbarHide={false}
                type='A'
                category='stay'
                onSwiper={onSwiper}
                onSwiperIndex={onSwiperIndex}
                enableAutoplay={enableAutoplay}
                autoplayDelay={autoplayDelay}
                list={partnerStoreList?.map((item) => (
                  <StayItemBox
                    key={item.id}
                    id={item.id}
                    type={isDesktop ? 'A' : 'B'}
                    stayInfo={item}
                    isDesktop={isDesktop}
                  />
                ))}
              />
            )}

            {type === 'pagination' && (
              <>
                <div>
                  <SwiperBox
                    isMargin={true}
                    slidesPerView={isDesktop ? 3 : 1}
                    scrollbarHide={isDesktop ? false : true}
                    type='B'
                    category='stay'
                    onSwiper={setSwiper}
                    onSwiperIndex={onSwiperIndex}
                    list={partnerStoreList?.map((item) => (
                      <StayItemBox key={item.id} id={item.id} type='B' stayInfo={item} isDesktop={isDesktop} />
                    ))}
                  />
                </div>
              </>
            )}
          </>
        )}
      </div>

      {type === 'pagination' && (partnerStoreList?.length ?? 0) > 3 && (
        <div className='flex gap-[8px] justify-center items-center text-[14px] mt-[40px] mobile:hidden'>
          <div>{swiperIndex ? Number(swiperIndex) + 1 : 1}</div>
          <div>/</div>
          <div>{partnerStoreList?.length}</div>
          <div className='cursor-pointer' onClick={handlePrev}>
            <Icons.LeftArrow />
          </div>
          <div className='cursor-pointer' onClick={handleNext}>
            <Icons.RightArrow />
          </div>
        </div>
      )}
    </div>
  );
};

export default StayListBox;
